<template>
  <base-section
    id="loan-estimate"
    class="text-center"
  >
    <div />
    <v-container>
      <v-row
        justify="center"
      >
        <v-col
          cols="12"
          md="6"
        >
          <div>
            <base-info-card
              :title="title"
              :subtitle="subTitle"
              space="4"
              color="primary"
            />
            <v-form>
              <!-- <v-text-field
                v-model="loanConfiguration.loanAmountBase"
                v-money="money"
                :error-messages="loanAmountBaseErrors"
                label="Enter your property address"
                required
                append-icon="mdi-arrow-right-circle"
                @click:append="debounceInput"
                @keydown.enter.prevent="debounceInput"
              /> -->

              <!-- <v-text-field
                v-model="address"
                label="Enter your property address"
                required
                append-icon="mdi-arrow-right-circle"
                @click:append="getPropertyValue"
                @keydown.enter.prevent="getPropertyValue"
              />
              :tick-labels="deferredYearsLabels"
              ticks="always"
              @input="calculateAll(isLoan)"
              -->
              <label for="slider">Enter your property value</label>
              <br><br>
              <v-slider
                id="slider"
                v-model="propertyValue"
                class="my-n6"
                step="5000"
                :max="2000000"
                :min="50000"
                tick-size="5"
                @input="updateCards"
              />
            </v-form>
          </div>
        </v-col>
      </v-row>
      <v-row
        v-show="propertyValue != 0"
        justify="center"
      >
        <v-col
          cols="12"
          md="4"
        >
          <h3>{{ propertyValueFormatted }}</h3>
        </v-col>
      </v-row>
      <v-row
        justify="center"
      >
        <v-col
          v-for="(plan, i) in heqStakingPlans"
          :key="i"
          cols="12"
          md="4"
        >
          <staking-card
            v-bind="plan"
            :is-monthly="i == 0"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import Finance from 'financejs'
  import _ from 'lodash'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'SectionStakingEstimate',
    components: {
      StakingCard: () => import('@/components/StakingComparisonCard'),
    },

    mixins: [validationMixin],
    validations: {
      loanConfiguration: {
        loanAmountBase: { required },
      },
    },
    provide: {
      heading: { align: 'center' },
    },

    data: () => ({
      address: '',
      propertyValue: 300000,
      stakingRate: 0.006,
      money: {
        prefix: '$ ',
        precision: 0,
      },
      title: 'Bank with Heq',
      subTitle: 'See how much you could earn by banking your property with Heq',
      // loanConfiguration: {
      //   term: 30,
      //   otherTerm: 30,
      //   deferredYears: 5,
      //   rate: 2,
      //   otherRate: 3.75,
      //   otherMonthlyPayment: 0,
      //   loanAmountBase: 0,
      // },
      // deferredYearsLabels: [1, 2, 3, 4, 5],
      internalPlans: [
        {
          title: 'Equity Banking',
          subtitle: 'Earn a monthly reward for banking your property with Heq',
          value: true,
          link: true,
          totalSavings: 0,
          features: [
            '1',
            '2',
            '3',
          ],
        },
        {
          title: 'Heq Equity Sharing',
          subtitle: 'Unlock the value of your home with an investment from Heq',
          value: true,
          link: true,
          totalSavings: 0,
          features: [
            '1',
            '2',
            '3',
          ],
        },
      ],
      interval: 0,
    }),

    computed: {
      propertyValueFormatted () {
        return `$${this.numberWithCommas(this.propertyValue)}`
      },

      heqStakingPlans () {
        return this.internalPlans.map(plan => {
          return {
            ...plan,
            feature: plan.feature,
            title: plan.title,
            // titleDescription: plan.titleDescription,
            subtitle: plan.subtitle,
            totalSavings: plan.totalSavings,
            // estimateData: plan.estimateData,
            // amSchedule: plan.amSchedule,
            // amAll: [this.internalCurrentPlans[0].amSchedule,
            //         this.internalCurrentPlans[1].amSchedule,
            //         this.internalCurrentPlans[2].amSchedule,
            //         this.internalCurrentPlans[3].amSchedule],
          }
        })
      },
    },

    beforeMount () {
      this.updateCards()
    },

    methods: {
      convertCurrencyToInt (val) {
        console.log('val', val, typeof val)
        const type = typeof val
        if (type === 'string') {
          return parseInt(val.replace(/\$/g, '').replace(/ /g, '').replace(/,/g, ''))
        } else if (type === 'number') {
          return val
        } else {
          return 0
        }
      },

      numberWithCommas (x) {
        return x.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },

      updateCards () {
        // maybe these should go in a description somewhere else?
        this.heqStakingPlans[0].features[0] = `Earn up to $${this.numberWithCommas((this.propertyValue * this.stakingRate) / 12)} a month in Heq rewards by using your property to back the HEQ token`
        this.heqStakingPlans[1].features[0] = `Receive an investment of up to $${this.numberWithCommas(this.propertyValue * 0.15)} from Heq. If your property value changes, Heq shares in the resulting loss or gain.`

        this.heqStakingPlans[0].features[1] = 'Earn more by committing to bank with us longer'
        this.heqStakingPlans[1].features[1] = 'Choose to unlock between 5% and 35% of your equity now'

        this.heqStakingPlans[0].features[2] = 'Need to move? There\'s no penalty - withdraw your property anytime'
        this.heqStakingPlans[1].features[2] = 'Choose between a 5-year and 30-year term customized to your needs'

        this.heqStakingPlans[0].totalSavings = this.propertyValue * this.stakingRate
        this.heqStakingPlans[1].totalSavings = this.propertyValue * 0.15
      },

    },
  }
</script>
